var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1663 11.8339L9.64219 20.3587C9.42063 20.2304 9.21074 20.1488 9.02416 20.1371C7.40329 20.0205 6.7736 20.2071 5.88737 19.4491C4.93117 18.6328 5.00114 16.452 5.00114 14.8543C5.00114 13.2567 4.93117 11.0759 5.88737 10.2596C6.7736 9.50156 7.40329 9.69981 9.02416 9.57153C10.645 9.44325 14.0733 4.49865 16.7204 6.06133C17.7932 6.93597 18.0847 8.56862 18.1663 11.8339Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1663 17.3965C18.1196 20.9883 17.8398 22.7376 16.7203 23.6472C15.4959 24.3702 14.1083 23.7055 12.8022 22.7609",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00195 25L9.643 20.3586L18.1671 11.8338L25.0005 5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/Volume Off.59fe893f.svg";
export { ForwardRef as ReactComponent };